module.exports = __webpack_public_path__ + "img/happytable_product3.8c956be2.jpg";